// Function to convert the JSON(Array of objects) to CSV.
const arrayToCSV = ( headers, data ) => {
  const csvRows = []

  // Add headers from format: { id: '', displayName: '' }
  const headerLabels = headers.map( header => header.displayName.replaceAll(',', '') )
  csvRows.push( headerLabels.join(',') )

  // Add data as comma separated values
  for ( const row of data ) {
    const currentRow = []
    headers.forEach( header => { currentRow.push( row[header.id] != null ? row[header.id].toString().replaceAll(',', '') : '' )})
    csvRows.push( currentRow.join(',') )
  }

  return csvRows.join('\n')
}

const downloadCSV = (data, fileName) => {
  const blob = new Blob([data], { type: 'text/csv' })
  const url = window.URL.createObjectURL(blob)
  const a = document.createElement('a')
  a.setAttribute('hidden', '')
  a.setAttribute('href', url)
  a.setAttribute('download', fileName + '.csv')
  document.body.appendChild(a)
  a.click()
  document.body.removeChild(a)
}

export const generateCSV = ( header, data, filename ) => {
  const csvData = arrayToCSV( header, data )
  downloadCSV( csvData,filename )
};
